import React, { useContext } from 'react';
import { CrudContext, usePromise, Widget } from '@digital/ui';
import { getAllDocumentacaoAcessoriaMensalByContrato } from '@app/api/contrato/documentacaoAcessoriaMensal';
import TableDocumentoMensal from './tableDocumentoMensal';
import { Collapse, Icon } from 'antd';

interface DocumentoAcessoriaProps {
  onUpdate: () => any;
  atualizar: boolean;
}

const DocumentacaoMensal = (props: DocumentoAcessoriaProps) => {
  const { onUpdate, atualizar } = props;
  const { Panel } = Collapse;
  const { selectedItem } = useContext(CrudContext);
  const [documentacoesAcessoria] = usePromise(
    () => (selectedItem ? getAllDocumentacaoAcessoriaMensalByContrato(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem, atualizar],
    [],
  );


  return (
    <>
      {documentacoesAcessoria.map(item => (
        <Collapse
          key={item.documentoMensalId + 'collapse'}
          bordered={false}
          defaultActiveKey={[item.documentoMensalId]}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key={item.documentoMensalId}
            header={item.ano + ' ' + item.mes + ' - ' + item.documentoMensalStatus}
            style={{ border: 0 }}>
            <Widget>
              <TableDocumentoMensal
                documentosAcessorio={item.documentosAcessorios}
                documentoMensalId={item.documentoMensalId}
              />
            </Widget>
          </Panel>
        </Collapse>
      ))}
    </>
  );
};

export default DocumentacaoMensal;
